// extracted by mini-css-extract-plugin
export default {"root":"NJAAeDiEAXkrgFsVZBjt","text":"sQmz9GcBO9aA4X2N2kv5"};